import apiService from "./apiService";
import AppConstants from "@/appConstants";
import EventEmitter from "events";

class PushwooshService extends EventEmitter {
  sendPublicDeviceId(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_USER_SEND_DEVICE_ID, form, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  sendClientDeviceId(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_CLIENT_SEND_DEVICE_ID, form, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  removeClientDeviceId(deviceId, params) {
    const url = `${AppConstants.URL_CLIENT_LOGOUT_DEVICE_ID}/${deviceId}`;
    return new Promise((resolve, reject) => {
      apiService.delete(url, params)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
export default new PushwooshService();
